import script from "./side-menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./side-menu.vue?vue&type=script&setup=true&lang=ts"

import "./side-menu.vue?vue&type=style&index=0&id=6f78a3bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f78a3bf"]])

export default __exports__